import { Flex, Text } from "styles/utility-components";

import { useDeleteBids } from "lib/hooks/api/bid/bids/useDeleteBids";
import { pluralise } from "lib/utils";
import Button from "../ui/button/Button";
import Modal from "../ui/modal/Modal";
import toast from "../ui/toast/Toast";

type Props = {
  isOpen: boolean;
  selectedBidIds: string[];
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
};

export default function DeleteBidsModal({
  isOpen,
  selectedBidIds,
  onOpenChange,
  onSuccess,
}: Props) {
  const { mutate: deleteBids, isLoading } = useDeleteBids({
    onSuccess: (data) => {
      toast.success(
        `${data.deleteBids.length > 1 ? pluralise(data.deleteBids.length, "bid") : "Bid"} deleted successfully`,
      );
      onSuccess();
    },
    onError: (_, vars) => toast.error(`Failed to delete ${vars.ids.length > 1 ? "bids" : "bid"}`),
  });

  return (
    <Modal open={isOpen} padding={24} onOpenChange={onOpenChange}>
      <Flex flexDirection="column" gap={16}>
        <Text h3 bold>
          {`Delete ${selectedBidIds.length > 1 ? "bids" : "bid"}`}
        </Text>
        <Text>
          {`Deleting ${selectedBidIds.length === 1 ? "this bid" : "these bids"} will also delete its associated reports and responses. Are you sure you want to delete ${selectedBidIds.length === 1 ? "this bid" : "these bids"}? This action cannot be undone.`}
        </Text>

        <Flex gap={16} justifyContent="flex-end">
          <Button buttonType="secondary" onClick={() => onOpenChange(false)}>
            Return to Bids
          </Button>
          <Button
            buttonStyle="destructive"
            onClick={() => deleteBids({ ids: selectedBidIds })}
            aria-label="Delete bids submit"
            loading={isLoading}
          >
            {`Delete ${selectedBidIds.length > 1 ? "bids" : "bid"}`}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
